import {Component, Input} from "@angular/core";
import {LookupService} from "../../lookup.service";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {Level, Message} from "../../../../model/message.component";
import {Router} from "@angular/router";
import {RiskFactor, ScreeningAlert} from "../../../../model/lookup-results.model";

@Component({
  selector: "admin-lookup-common-rules",
  templateUrl: "./rules.component.html",
  styleUrls: ["./rules.component.css"]
})
export class AdminLookupCommonRulesComponent {

  @Input() factor: RiskFactor = new RiskFactor();

  constructor(
    private singleService: LookupService,
    private viewManager: ViewManagerService
  ) {
  }


  riskClass(factor: RiskFactor) {
    return this.singleService.riskClass(factor.risk!);
  }

  getNumberValue(value: number | undefined) {
    return value ?? 0.0;
  }
}
